import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter, Link } from 'react-router-dom'
import moment from 'moment'
import styled from 'styled-components'
import { actions } from '../redux/modules/leadDetails'
import { actions as userActions } from '../redux/modules/userActions'
import {
  Input,
  Select,
  Form,
  message,
  Col,
  AutoComplete,
  Icon,
  Button,
  DatePicker,
  Popconfirm
} from 'antd'
import CloneLeadForm from './leads/CloneLeadForm'
import CreateJobForm from '../pages/lead/components/CreateJobForm'
import _ from 'lodash'
import { actions as organizationsActions } from '../redux/modules/organizationsActions'
import { actions as companiesActions } from '../redux/modules/companiesActions'
import OrganizationQuickAdd from '../components/organization//OrganizationQuickAdd'
import { convertToOption, getSelectedOrganization } from '../util'

import 'react-table/react-table.css'
import 'antd/dist/antd.css'

const ButtonsArea = styled.div`
  padding-bottom: 20px;
`

const propTypes = {}
const Option = Select.Option
const FormItem = Form.Item

class LeadDetails extends Component {
  constructor(props) {
    super(props)

    this.state = {
      modalVisible: false,
      modalCreateJobVisible: false
    }

    this.props.getAllCompanies()

    this.props.fetchLeadDetails({
      leadId: this.props.match.params.leadId
    })
    this.props.getUsers()
    this.props.fetchContracts({
      leadId: this.props.match.params.leadId
    })
  }

  filterUserList = () => {
    var filteredUsers = []
    if (
      this.props.userActions &&
      this.props.userActions.users &&
      this.props.userActions.users.data
    ) {
      filteredUsers = this.props.userActions.users.data.map(user => {
        const newObj = {
          value: user.id,
          text: `${user.first_name} ${user.last_name}`
        }
        return newObj
      })
    }
    return filteredUsers
  }

  getAssignedToId = (assignedTo, initialValueAutocompleteIndex) => {
    let assignedToId = null
    if (Number.isInteger(parseInt(assignedTo, 10))) {
      assignedToId = assignedTo
    } else {
      const filteredUserList = this.filterUserList()

      assignedToId =
        filteredUserList &&
        filteredUserList[initialValueAutocompleteIndex] &&
        filteredUserList[initialValueAutocompleteIndex].id
    }
    return assignedToId
  }

  handleSaveJobClick = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      const initialValueAutocompleteIndex = this.filterUserList().findIndex(user => {
        const { payload } = this.props.leadDetails

        return (
          user.text ===
          `${payload.data.assigned_to_first_name} ${payload.data.assigned_to_last_name}`
        )
      })

      values.organization_id = getSelectedOrganization(
        this.props.companiesActions.payload.data,
        values.organization_id
      )

      const param = {
        // -- job
        type: values.jobType,
        name: values.name,
        description: values.jobDescription,
        updated_by_id: this.props.authentication.user.userId,
        organization_id: values.organization_id,
        bid_due_date: values.bid_due_date
          ? moment(values.bid_due_date)
              .endOf('day')
              .format('YYYY-MM-DD HH:mm:ss')
          : null,
        // -- user
        assigned_to_id: this.getAssignedToId(values.assignedTo, initialValueAutocompleteIndex),
        // -- adress
        city: values.city,
        address1: values.address1,
        address2: values.address2,
        state: values.state,
        zip: values.zip
      }

      if (this.props.leadStatus !== false) {
        var statusLeadDecoded = ''
        switch (this.props.leadStatus) {
          case 25:
            statusLeadDecoded = 'estimate'
            break
          case 50:
            statusLeadDecoded = 'proposal'
            break
          case 75:
            statusLeadDecoded = 'contract'
            break
          case 100:
            statusLeadDecoded = 'complete'
            break
          default:
            statusLeadDecoded = 'research'
            break
        }

        param.status = statusLeadDecoded
      }

      this.props.updateLeadDetails({
        leadId: this.props.match.params.leadId,
        content: param
      })
      message.success('Job details saved.')
      this.props.handleEditJobClick()
    })
  }

  // following the existing flow calling the delete from component
  handleDeleteLead = () => {
    this.props.deleteLead({
      leadId: this.props.match.params.leadId
    })
  }

  handleMarkAsDeadLead = markAsAlive => {
    this.props.markAsDeadLead({
      leadId: this.props.match.params.leadId,
      markAsAlive: markAsAlive
    })
  }

  handleToggleCloneLeadForm = () => {
    this.setState({
      modalVisible: !this.state.modalVisible
    })
  }

  handleCloneLead = leadName => {
    this.props.cloneLead({
      leadId: this.props.match.params.leadId,
      leadName: leadName
    })

    message.success('Lead cloned!')
    this.handleToggleCloneLeadForm()
  }

  handleToggleCreateJobForm = () => {
    this.setState({
      modalCreateJobVisible: !this.state.modalCreateJobVisible
    })
  }

  handleCreateJob = params => {
    params.updated_by_id = this.props.authentication.user.userId
    params.created_by_id = this.props.authentication.user.userId
    params.assigned_to_id = this.props.authentication.user.userId
    this.props.createJobFromLead({
      leadId: this.props.match.params.leadId,
      content: params
    })

    message.success('Job Created!')
    this.handleToggleCreateJobForm()
  }

  /* Organization Quick Add */
  handleQuickAddOrganization = organization => {
    this.props.createNewOrganization({
      organization: organization,
      userId: this.props.authentication.user.userId
    })
    setTimeout(() => {
      this.props.getAllCompanies()
    }, 1000)
  }

  handleBlurOrganization = organization => {
    if (organization !== '')
      this.setState({
        quickAddModalVisibility:
          _.findIndex(this.props.companiesActions.payload.data, { id: +organization }) < 0 &&
          _.findIndex(this.props.companiesActions.payload.data, { name: organization }) < 0
            ? true
            : false
      })
  }

  handleCancelQuickAdd = () => {
    this.setState({
      quickAddModalVisibility: !this.state.quickAddModalVisibility
    })
  }
  /* End Organization Quick Add */

  render() {
    const { getFieldDecorator } = this.props.form
    const { payload, contracts } = this.props.leadDetails
    const allCompanies =
      this.props.companiesActions &&
      this.props.companiesActions.payload &&
      this.props.companiesActions.payload.data
    if (!payload) {
      return (
        <div>
          <div className="jobsBar">
            Lead Details
            <div className="jobsBarAdd">
              <i className="fa fa-pencil-square" aria-hidden="true" />
              &nbsp;<div className="addJobLabel">EDIT JOB</div>
            </div>
          </div>
          <div className="jobLoading">
            <i className="fa fa-refresh fa-spin fa-3x fa-fw" />
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      )
    } else {
      return (
        <div>
          <OrganizationQuickAdd
            modalVisible={this.state.quickAddModalVisibility}
            handleCancel={this.handleCancelQuickAdd}
            handleQuickAddOrganization={this.handleQuickAddOrganization}
            organizartionType={'Client'}
          />
          <CloneLeadForm
            modalVisible={this.state.modalVisible}
            handleCloneLead={this.handleCloneLead}
            handleToggleCloneLeadForm={this.handleToggleCloneLeadForm}
          />
          <CreateJobForm
            contracts={contracts && contracts.data}
            modalVisible={this.state.modalCreateJobVisible}
            handleCreateJob={this.handleCreateJob}
            handleToggleCreateJobForm={this.handleToggleCreateJobForm}
          />
          <div className="jobsBar">
            Lead Details
            {!this.props.isEditing && (
              <div className="jobsBarAdd" onClick={() => this.props.handleEditJobClick()}>
                <i className="fa fa-pencil-square" aria-hidden="true" />
                &nbsp;<div className="addJobLabel">EDIT LEAD</div>
              </div>
            )}
            {this.props.isEditing && (
              <div className="displayFlex">
                <div className="jobsBarAdd" onClick={() => this.handleSaveJobClick()}>
                  <i className="fa fa-save" aria-hidden="true" />
                  &nbsp;<div className="addJobLabel">SAVE CHANGES</div>
                </div>
                <div className="jobsBarAdd" onClick={() => this.props.handleEditJobClick()}>
                  <i className="fa fa-ban" aria-hidden="true" />
                  &nbsp;<div className="addJobLabel">CANCEL</div>
                </div>
              </div>
            )}
          </div>
          {payload.data ? (
            <Form>
              <div className="jobDetails">
                <div className="row">
                  <div className="col-md-12">
                    <ButtonsArea>
                      {payload.data.status === 'contract' && (
                        <Button
                          className="marginRight10"
                          onClick={() => this.handleToggleCreateJobForm()}
                          icon="folder-add"
                          type="primary"
                        >
                          Create Job
                        </Button>
                      )}
                      <Button
                        className="marginRight10"
                        onClick={() => this.handleToggleCloneLeadForm()}
                        icon="copy"
                      >
                        Clone Lead
                      </Button>
                      <Popconfirm
                        title="Are you sure you want to delete this Lead?"
                        onConfirm={() => this.handleDeleteLead()}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button className="marginRight10" type="danger" icon="delete">
                          Delete Lead
                        </Button>
                      </Popconfirm>
                      {payload.data.dead !== 1 && (
                        <Popconfirm
                          title="Are you sure you want to mark as dead this Lead?"
                          onConfirm={() => this.handleMarkAsDeadLead(false)}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Button type="danger" icon="close">
                            Mark as Dead
                          </Button>
                        </Popconfirm>
                      )}
                      {payload.data.dead === 1 && (
                        <Popconfirm
                          title="Are you sure you want to mark as alive this Lead?"
                          onConfirm={() => this.handleMarkAsDeadLead(true)}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Button
                            type="default"
                            style={{ backgroundColor: 'green', color: 'white' }}
                            icon="arrow-up"
                          >
                            Mark as Alive
                          </Button>
                        </Popconfirm>
                      )}
                    </ButtonsArea>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <div className="jobDetailsHeader">CREATED DATE</div>
                    {`${moment(payload.data.created_date).format('M/D/YYYY h:mm:ssa')}`}
                  </div>
                  <div className="col-md-3">
                    <div className="jobDetailsHeader">UPDATED DATE</div>
                    {`${moment(payload.data.updated_date).format('M/D/YYYY h:mm:ssa')}`}
                  </div>
                  <div className="col-md-3">
                    <div className="jobDetailsHeader">CREATED BY</div>
                    {`${payload.data.created_by_first_name} ${payload.data.created_by_last_name}`}
                  </div>
                  <div className="col-md-3">
                    <div className="jobDetailsHeader">UPDATED BY</div>
                    {`${payload.data.updated_by_first_name} ${payload.data.updated_by_last_name}`}
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-3">
                    <div className="jobDetailsHeader">NAME</div>
                    {!this.props.isEditing && `${payload.data.name}`}
                    {this.props.isEditing && (
                      <FormItem>
                        {getFieldDecorator('name', {
                          rules: [
                            {
                              required: true,
                              message: 'Please input the JOB Name!'
                            }
                          ],
                          initialValue: payload.data.name
                        })(<Input id="name" />)}
                      </FormItem>
                    )}
                  </div>
                  <div className="col-md-3">
                    <div className="jobDetailsHeader">TYPE</div>
                    {this.props.isEditing && (
                      <FormItem>
                        {getFieldDecorator('jobType', {
                          initialValue: payload.data.type
                        })(
                          <Select
                            showSearch
                            style={{ width: 200 }}
                            placeholder="Select a type"
                            optionFilterProp="children"
                            initialValue={payload.data.type}
                            onChange={this.handleChangeSelectType}
                            onFocus={this.handleFocusSelectType}
                            onBlur={this.handleBlurSelectType}
                            filterOption={(input, option) =>
                              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            <Option value="MRL">MRL</Option>
                            <Option value="HC">HC</Option>
                            <Option value="TC">TC</Option>
                            <Option value="M">M</Option>
                            <Option value="MOD">MOD</Option>
                            <Option value="R">R</Option>
                            <Option value="S">S</Option>
                            <Option value="HMS">HMS</Option>
                          </Select>
                        )}
                      </FormItem>
                    )}
                    {!this.props.isEditing && `${payload.data.type}`}
                  </div>
                  <div className="col-md-3">
                    <div className="jobDetailsHeader">COMPANY NAME</div>
                    {this.props.isEditing && (
                      <FormItem>
                        {getFieldDecorator('organization_id', {
                          initialValue: payload.data.company_name
                        })(
                          <AutoComplete
                            dataSource={convertToOption(allCompanies)}
                            filterOption={(inputValue, option) =>
                              option.props.children
                                .toUpperCase()
                                .indexOf(inputValue.toUpperCase()) !== -1
                            }
                            placeholder="Search for some Company"
                            width={320}
                            onBlur={this.handleBlurOrganization}
                          >
                            <Input
                              suffix={<Icon type="search" className="certain-category-icon" />}
                            />
                          </AutoComplete>
                        )}
                      </FormItem>
                    )}
                    {!this.props.isEditing && (
                      <Link to={`/companies/${payload.data.company_id}`}>
                        {payload.data.company_name}
                      </Link>
                    )}
                  </div>
                  <div className="col-md-3">
                    <div className="jobDetailsHeader">ASSIGNED TO</div>
                    {this.props.isEditing && (
                      <FormItem>
                        {getFieldDecorator('assignedTo', {
                          initialValue: `${payload.data.assigned_to_first_name} ${
                            payload.data.assigned_to_last_name
                          }`
                        })(
                          <AutoComplete
                            dataSource={
                              this.props.userActions &&
                              this.props.userActions.users &&
                              this.filterUserList()
                            }
                          >
                            <Input
                              suffix={<Icon type="search" className="certain-category-icon" />}
                            />
                          </AutoComplete>
                        )}
                      </FormItem>
                    )}
                    {!this.props.isEditing && (
                      <div>
                        {`${payload.data.assigned_to_first_name} ${
                          payload.data.assigned_to_last_name
                        }`}
                      </div>
                    )}
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-3">
                    <div className="jobDetailsHeader">DESCRIPTION</div>
                    {!this.props.isEditing && `${payload.data.description}`}
                    {this.props.isEditing && (
                      <FormItem>
                        {getFieldDecorator('jobDescription', {
                          initialValue: payload.data.description
                        })(<Input id="description" />)}
                      </FormItem>
                    )}
                  </div>
                  <div className="col-md-3">
                    <div className="jobDetailsHeader">BID DUE DATE</div>
                    {this.props.isEditing && (
                      <FormItem label="">
                        {getFieldDecorator('bid_due_date', {
                          rules: [
                            {
                              required: true,
                              message: 'Bid due date cannot be blank.'
                            }
                          ],
                          initialValue: payload.data.bid_due_date
                            ? moment(payload.data.bid_due_date)
                            : null
                        })(<DatePicker />)}
                      </FormItem>
                    )}
                    {!this.props.isEditing &&
                      payload.data.bid_due_date &&
                      moment(payload.data.bid_due_date).format('M/D/YYYY')}
                  </div>
                  <div className="col-md-3">
                    <div className="jobDetailsHeader">PROPOSAL SENT</div>
                    {payload.data.proposal_sent === 1 && (
                      <div>
                        <Link
                          to={`/lead/${this.props.match.params.leadId}/proposals/edit/${
                            payload.data.sent_proposal_id
                          }`}
                        >
                          #{payload.data.sent_proposal_id}
                        </Link>{' '}
                        at {moment(payload.data.proposal_sent_date).format('M/D/YYYY')}
                      </div>
                    )}
                    {payload.data.proposal_sent !== 1 && <div>Proposal Not Sent</div>}
                  </div>
                  <div className="col-md-3">
                    <div className="jobDetailsHeader">CONTRACT SENT</div>
                    {payload.data.contract_sent === 1 && (
                      <div>
                        <Link
                          to={`/lead/${this.props.match.params.leadId}/contracts/edit/${
                            payload.data.sent_contract_id
                          }`}
                        >
                          #{payload.data.sent_contract_id}
                        </Link>{' '}
                        at {moment(payload.data.contract_sent_date).format('M/D/YYYY')}
                      </div>
                    )}
                    {payload.data.contract_sent !== 1 && <div>Contract Not Sent</div>}
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-6">
                    <div className="jobDetailsHeader">ADDRESS</div>
                    {!this.props.isEditing && `${payload.data.address1}`}
                    {!this.props.isEditing &&
                      payload.data.address2 &&
                      ` - ${payload.data.address2}`}
                    {!this.props.isEditing && <br />}
                    {this.props.isEditing && (
                      <FormItem>
                        {getFieldDecorator('address1', {
                          initialValue: payload.data.address1
                        })(<Input id="address1" placeholder="Address" />)}
                      </FormItem>
                    )}
                    {this.props.isEditing && (
                      <FormItem>
                        {getFieldDecorator('address2', {
                          initialValue: payload.data.address2
                        })(<Input id="address2" placeholder="Address (cont)" />)}
                      </FormItem>
                    )}
                    {!this.props.isEditing && `${payload.data.city}, `}
                    {this.props.isEditing && (
                      <FormItem>
                        {getFieldDecorator('city', {
                          initialValue: payload.data.city
                        })(<Input id="city" placeholder="City" />)}
                      </FormItem>
                    )}
                    {!this.props.isEditing && `${payload.data.state}`}
                    {!this.props.isEditing && payload.data.zip && ` - ${payload.data.zip}`}
                    <FormItem>
                      {this.props.isEditing && (
                        <Col span={11}>
                          <FormItem>
                            {getFieldDecorator('state', {
                              initialValue: payload.data.state
                            })(<Input id="state" placeholder="State" />)}
                          </FormItem>
                        </Col>
                      )}
                      {this.props.isEditing && (
                        <Col span={2}>
                          <span
                            style={{ display: 'inline-block', width: '100%', textAlign: 'center' }}
                          >
                            -
                          </span>
                        </Col>
                      )}
                      {this.props.isEditing && (
                        <Col span={11}>
                          <FormItem>
                            {getFieldDecorator('zip', {
                              initialValue: payload.data.zip
                            })(<Input id="zip" placeholder="Zip" />)}
                          </FormItem>
                        </Col>
                      )}
                    </FormItem>
                  </div>
                </div>
              </div>
            </Form>
          ) : (
            <div>something went wrong</div>
          )}
        </div>
      )
    }
  }
}

const mapStateToProps = (
  { leadDetails, userActions, authentication, organizationsActions, companiesActions },
  ownProps
) => ({
  leadDetails,
  userActions,
  authentication,
  organizationsActions,
  companiesActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    Object.assign({}, actions, userActions, organizationsActions, companiesActions),
    dispatch
  )
})

LeadDetails.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(LeadDetails)))



// WEBPACK FOOTER //
// ./src/components/LeadDetails.js